import { memo, type PropsWithChildren, useCallback, useState } from "react"

import { PolygonPickerOverlay } from "../../components/Overlays/PolygonPicker"
import { PolygonPickerContext } from "./context"
import type { PolygonPickerConfig } from "./typings"

interface PolygonPickerProviderProps extends PropsWithChildren {
	onOpenChange?: (open: boolean) => void
}

export const PolygonPickerProvider = memo<PolygonPickerProviderProps>((props) => {
	const { children, onOpenChange } = props
	const [config, setConfig] = useState<PolygonPickerConfig | null>(null)

	const close = useCallback(() => {
		setConfig(null)
		onOpenChange?.(false)
	}, [onOpenChange])

	const open = useCallback(
		(func: (close: () => void) => PolygonPickerConfig) => {
			setConfig(func(close))
			onOpenChange?.(true)
		},
		[close, onOpenChange],
	)

	return (
		<PolygonPickerContext value={open}>
			{children}
			{config && (
				<PolygonPickerOverlay
					initialPolygon={config.initialPolygon}
					onConfirm={config.onConfirm}
					onCancel={config.onCancel}
				/>
			)}
		</PolygonPickerContext>
	)
})
PolygonPickerProvider.displayName = "PolygonPickerProvider"
